export default function BreadcrumbsSection() {
	return (
		<div className="fugu--breadcrumbs-section">
			<div className="fugu--breadcrumbs-data">
				<h1>Blog & Resources</h1>
				<p>
					Your source of market analysis, news, developments, and project reviews for the NFT ecosystem.
					Discover and keep up to date with the latest NFT.
				</p>
			</div>
		</div>
	);
}
